import { render, staticRenderFns } from "./EventsAdmin.vue?vue&type=template&id=36917ea8&scoped=true"
import script from "./EventsAdmin.vue?vue&type=script&lang=js"
export * from "./EventsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36917ea8",
  null
  
)

export default component.exports